// extracted by mini-css-extract-plugin
module.exports = {"modal":"_1PzCT2","items":"_1K6Yui","tag":"_3_U2-c","tagText":"_3qmPY2","image":"CvW3OP","text":"_2cVphI","item":"_3IVFkc","button":"_2uqrZi","shine-lines":"_3riuel"};